import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

export const containerStyle = {
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [Device.fullHD]: {
    position: appConfig.authFormCentered && 'relative',
    top: appConfig.authFormCentered && 150
  }
};
